const createBrandFormInitialValues = (originalName, website) => ({
  originalName,
  website,
  name: '',
})

export default createBrandFormInitialValues
